const RETURN_URL_KEY = "gympin-return-url";

const RETURNABLE_PREFIXES = ["/tickets", "/wallet", "/basket", "/favorites"];

function isReturnablePath(pathname) {
    return RETURNABLE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(prefix + "/"));
}

export function rememberReturnUrl(pathname, search = "") {
    try {
        if (!pathname || !isReturnablePath(pathname)) {
            sessionStorage.removeItem(RETURN_URL_KEY);
            return;
        }
        const next = `${pathname}${search || ""}`;
        if (!next.startsWith("/") || next.startsWith("//")) return;
        sessionStorage.setItem(RETURN_URL_KEY, next);
    } catch {
        // sessionStorage ممکن است در حالت خصوصی در دسترس نباشد
    }
}

export function consumeReturnUrl() {
    try {
        const value = sessionStorage.getItem(RETURN_URL_KEY);
        sessionStorage.removeItem(RETURN_URL_KEY);
        if (!value || !value.startsWith("/") || value.startsWith("//")) return "/";
        const pathname = value.split("?")[0];
        if (!isReturnablePath(pathname)) return "/";
        return value;
    } catch {
        return "/";
    }
}
